module.exports = __webpack_public_path__ + "static/architecture-28116c2f0f5f0daadd2b2655e6287534.png";